import { Component, DoCheck, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TransactionDetailsPage } from 'src/app/shared/modals/transaction-details/transaction-details.page';
import { AuthenticationService } from 'src/app/shared/_services';

@Component({
  selector: 'app-pending',
  templateUrl: './pending.page.html',
  styleUrls: ['./pending.page.scss'],
})
export class PendingPage implements OnInit, DoCheck {
  transactionDetails = [];
  pendingTransactions = [];
  currentUser: any;

  constructor(private modalController: ModalController, private auth: AuthenticationService) {
    this.currentUser = this.auth.currentUserValue;
  }
  async openTransactionDetails(transactionDetail: any) {
    const modal = await this.modalController.create({
      component: TransactionDetailsPage,
      backdropDismiss: true,
      cssClass: 'bottom-modal create-dispute',
      componentProps: {
        transactionDetail
      }
    });
    return await modal.present();
  }

  getPendingTransactions() {
    this.transactionDetails.forEach(transactionDetail => {
      if (transactionDetail.virtualAccount && transactionDetail.notification.queryResponse === null) {
        this.pendingTransactions.push(transactionDetail.virtualAccount);
      }
      if (transactionDetail.ussdString && transactionDetail.responseCode === '09') {
        this.pendingTransactions.push(transactionDetail.ussdString);
      }
    });
  }

  ionViewDidEnter() {
    this.getPendingTransactions();
  }

  ionViewDidLeave() {
    this.pendingTransactions = [];
  }

  ngOnInit() {
    this.transactionDetails = JSON.parse(localStorage.getItem('transactionDetails'));
    console.log(this.transactionDetails);
  }

  ngDoCheck(): void {
    if (localStorage.getItem('refreshedPending') === 'true') {
      this.transactionDetails = JSON.parse(localStorage.getItem('transactionDetails'));
      localStorage.setItem('refreshedPending', 'false');
    }
  }

}
